/* eslint-disable @next/next/no-img-element */
import axios from 'axios';
import { useFormik } from 'formik';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import Container from '../../atoms/Container';
import Styles from './RastreadoresFormV2.css';
import Step1 from './Step1';
import Step2 from './Step2';
import Step3 from './Step3';
import { getValidator, Step1Validation, Step2Validation, Step3Validation } from './Validator';
import moment from 'moment';
import 'moment-timezone';
import LoadingModal from '../LoadingModal/LoadingModal';
import RastreadoresModal from '../RastreadoresModal/RastreadoresModal';

function RastreadoresFormV2() {
  const [currentStep, setCurrentStep] = useState(1);
  const [validationSchema, setValidationSchema] = useState(getValidator(1, {}));
  const isLastStep = useMemo(() => currentStep === 3, [currentStep]);
  const [loading, setLoading] = useState(false);
  const [modalResult, setModalResult] = useState({
    visible: false,
    success: false,
    title: '',
    text: '',
  });

  const handleSubmit = useCallback(
    async (values) => {
      if (loading || currentStep !== 3) return;

      const client = axios.create({
        baseURL: process.env.NEXT_PUBLIC_RAST_API,
      });

      setLoading(true);
      try {
        const installDate = moment.tz(values.installDate, 'America/Sao_Paulo').format('yyyy-MM-DD');

        const res = await client.post('/public/schedule', {
          Store: {
            Name: values.storeName,
            Address: `${values.storeAddress} ${values.storeNumber}`,
            ZipCode: values.storeZipcode.replace(/\D/gi, ''),
            District: values.storeDistrict,
            City: values.storeCity,
            State: values.storeState,
            AddressNumber: values.storeNumber,
            Complement: values.storeComplement,
          },
          Responsible: {
            PhoneNumber: values.responsiblePhone.replace(/\D/gi, ''),
            PhoneNumber2: values.responsiblePhone2?.replace(/\D/gi, ''),
            Email: values.responsibleEmail,
            Name: values.responsibleName,
            Cpf: values.clientCPF.replace(/\D/gi, ''),
          },
          Vehicle: {
            PlateNumber: values.vehiclePlate?.replace(/-/gi, ''),
            Chassi: values.vehicleChassi,
            Fipe: values.vehicleModel,
          },
          Schedule: {
            ScheduleDate: `${installDate} ${values.installTime}`,
            ServiceType: 1, // sempre agendado
          },
          ProposalNumber: values.proposalNumber,
          OperationType: 1,
        });

        const chassi = parseInt(
          values.vehicleChassi.trim().charAt(values.vehicleChassi.trim().length - 1),
          10,
        );

        let msg = `Agora aguarde a visita do técnico da Ituran no local indicado. Para qualquer dúvida entre em contato pelo telefone: 0800 750 0038. <br />
        Ou pelo Whatsapp: <a href="https://web.whatsapp.com/send?phone=551136169086" target={'_blank'} rel="noopener">(11) 3616-9086</a> `;

        // if (![1, 3].includes(chassi)) {
        //   msg = `Agora aguarde a visita do técnico da Ituran no local indicado. Para qualquer dúvida entre em contato pelo telefone: 0800 750 0038. <br />
        //   Ou pelo Whatsapp: <a href="https://web.whatsapp.com/send?phone=551136169086" target={'_blank'} rel="noopener">(11) 3616-9086</a> `;
        // } else {
        //   msg = `Agora aguarde a visita do técnico da SAT no local indicado. Para qualquer dúvida entre em contato pelo telefone: 0800 888 8910`;
        // }

        setModalResult({
          success: true,
          title: 'Sua solicitação foi realizada com sucesso',
          text: msg,
          visible: true,
        });

        form.resetForm();
        setCurrentStep(1);
      } catch (error) {
        const chassi = parseInt(
          values.vehicleChassi.trim().charAt(values.vehicleChassi.trim().length - 1),
          10,
        );

        let msg = '';

        // if (![1, 3].includes(chassi)) {
        msg = `Por favor entre em contato com a empresa parceira (Ituran), pelo telefone: 0800 750 0038. <br />
          Ou pelo Whatsapp: <a href="https://web.whatsapp.com/send?phone=551136169086" target={'_blank'} rel="noopener">(11) 3616-9086</a> `;

        if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.error === 'ITURAN_ERROR ## vehicle not found'
        ) {
          msg = `
              Placa e/ou chassi inválidos.<br>
              Por favor verifique suas informações.
            `;
        }
        // } else {
        //   msg = `Por favor entre em contato com a empresa parceira (SAT), pelo telefone: 0800 888 8910`;
        // }

        setModalResult({
          success: false,
          title: 'Não foi possível realizar sua solicitação',
          text: msg,
          visible: true,
        });
      } finally {
        setLoading(false);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [currentStep, loading],
  );

  const form = useFormik({
    initialValues: {
      // step 1
      responsibleName: '',
      responsiblePhone: '',
      responsiblePhone2: '',
      responsibleEmail: '',
      clientCPF: '',
      proposalNumber: '',
      // step 2
      storeName: '',
      storeZipcode: '',
      storeAddress: '',
      storeNumber: '',
      storeComplement: '',
      storeDistrict: '',
      storeCity: '',
      storeState: '',
      //step 3,
      vehicleType: '',
      vehicleModel: '',
      vehicleChassi: '',
      vehicleChassi2: '',
      vehiclePlate: '',
      installDate: '',
      installTime: '',
    },
    validationSchema,
    onSubmit: handleSubmit,
  });

  useEffect(() => {
    setValidationSchema(getValidator(currentStep, form.values));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentStep, form.values.vehicleChassi2, form.values.vehicleType]);

  return (
    <>
      <section id="instalacao">
        <Container>
          {/* <picture className="logo-sntd">
            <source media="(min-width: 992px)" srcSet="assets/rastreadores/logo-sntd.svg" /> */}
          <img src="assets/rastreadores/logo-sntd.svg" alt="" className="logo-sntd" />
          {/* </picture> */}
          <div className="conteudo">
            <div className="recomendacoes">
              <div className="recomendacoes-card">
                <h3 className="rec-title">Contratação</h3>
                <div className="steps-card">
                  <div className="step-title">
                    <h4
                      style={{
                        fontSize: '32px',
                        borderRight: '1px solid #CC0000',
                        height: '34px',
                        paddingRight: '8px',
                      }}
                    >
                      1
                    </h4>
                    <h4>Formulário</h4>
                  </div>
                  <p>
                    Preencha os campos do
                    <br /> formulário ao lado e<br /> agende a visita técnica.
                  </p>
                </div>
                <div className="steps-card">
                  <div className="step-title">
                    <h4
                      style={{
                        fontSize: '32px',
                        borderRight: '1px solid #CC0000',
                        height: '34px',
                        paddingRight: '8px',
                      }}
                    >
                      2
                    </h4>
                    <h4>Comprovante</h4>
                  </div>
                  <p>
                    Inclua o comprovante
                    <br /> da visita do técnico
                    <br /> na plataforma de
                    <br /> financiamento.
                  </p>
                </div>
                <div className="steps-card">
                  <div className="step-title">
                    <h4
                      style={{
                        fontSize: '32px',
                        borderRight: '1px solid #CC0000',
                        height: '34px',
                        paddingRight: '8px',
                      }}
                    >
                      3
                    </h4>
                    <h4>Crédito</h4>
                  </div>
                  <p>
                    Pronto! Agora é só
                    <br /> aguardar a liberação do
                    <br /> seu crédito!
                  </p>
                </div>
              </div>

              <div className="recomendacoes-card-2">
                <h3 className="rec-title">Recomendações</h3>
                <ul>
                  <li>
                    <p>
                      A instalação <b>não</b> poderá ser acompanhada pelo cliente, nem realizada em
                      local no subsolo. A instalação deve ser feita em local restrito, coberto e
                      amplo, propiciando abertura de portas.
                    </p>
                  </li>
                  <li>
                    <p>
                      Caso seja necessário movimentar o veículo, é <b>exigida</b> a presença de
                      pessoa autorizada pelo lojista ou cliente.
                    </p>
                  </li>
                  <li>
                    <p>
                      O responsável pela instalação deverá assinar o Documento Eletrônico de
                      <b> comprovação de instalação do rastreador.</b>
                    </p>
                  </li>
                </ul>
              </div>
              {/* </Container> */}
            </div>

            <div className="form" id="rastreadores-formulario">
              {/* <Container> */}
              <h3>
                <b>Preencha o formulário</b> para solicitar a instalação do <b>rastreador:</b>
              </h3>
              <div className="titulo-steps">
                <p className={currentStep == 1 ? 'active' : ''}>1. Dados pessoais</p>
                <p className={currentStep == 2 ? 'active' : ''}>2. Dados da loja</p>
                <p className={currentStep == 3 ? 'active' : ''}>3. Dados do veículo</p>
              </div>
              <div className="steps">
                <span className={currentStep >= 1 ? 'active' : ''} />
                <span className={currentStep >= 2 ? 'active' : ''} />
                <span className={currentStep >= 3 ? 'active' : ''} />
              </div>
              <div className="texto-steps">
                <p className={currentStep == 1 ? 'active' : ''}>Passo 1 de 3</p>
                <p className={currentStep == 2 ? 'active' : ''}>Passo 2 de 3</p>
                <p className={currentStep == 3 ? 'active' : ''}>Passo 3 de 3</p>
              </div>
              <form id="schedule" onSubmit={form.handleSubmit}>
                {currentStep === 1 && (
                  <Step1
                    handleChange={form.handleChange}
                    handleBlur={form.handleBlur}
                    values={form.values}
                    touched={form.touched}
                    errors={form.errors}
                  />
                )}

                {currentStep === 2 && (
                  <Step2
                    handleChange={form.handleChange}
                    handleBlur={form.handleBlur}
                    values={form.values}
                    setFieldValue={form.setFieldValue}
                    touched={form.touched}
                    errors={form.errors}
                  />
                )}

                {currentStep === 3 && (
                  <Step3
                    handleChange={form.handleChange}
                    handleBlur={form.handleBlur}
                    values={form.values}
                    setFieldValue={form.setFieldValue}
                    touched={form.touched}
                    errors={form.errors}
                    setTouched={form.setTouched}
                  />
                )}

                <div className={currentStep === 1 ? 'form-actions one-button' : 'form-actions'}>
                  {currentStep > 1 && (
                    <button
                      className="back"
                      type="button"
                      onClick={(e) => {
                        e.preventDefault();
                        setCurrentStep(Math.max(currentStep - 1, 1));
                      }}
                    >
                      Voltar
                    </button>
                  )}
                  <button
                    className="next"
                    type="button"
                    onClick={(e) => {
                      e.preventDefault();

                      form.validateForm().then((value) => {
                        if (!value || Object.keys(value).length === 0) {
                          const validatedFields = validationSchema.fields;
                          const formFields = form.values;

                          if (!isLastStep) {
                            // esconde erros

                            const touched = {};

                            Object.keys(formFields).forEach((k) => {
                              touched[k] = false;
                            });

                            Object.keys(validatedFields).forEach((k) => {
                              touched[k] = true;
                            });

                            form.setTouched(touched, false).then(() => {
                              setCurrentStep(Math.min(currentStep + 1, 3));
                            });
                          } else {
                            setCurrentStep(Math.min(currentStep + 1, 3));
                          }
                        } else {
                          // força mostrar os erros
                          if (!isLastStep) {
                            form.submitForm();
                          }
                        }

                        if (isLastStep) {
                          form.submitForm();
                          return;
                        }
                      });
                    }}
                  >
                    {isLastStep ? 'Solicitar' : 'Avançar'}
                  </button>
                </div>

                {isLastStep && (
                  <div className="disclaimer-install">
                    <p>
                      *Os períodos disponíveis podem variar de acordo com o momento que foram
                      agendados, então, após a solicitação aguarde o contato da equipe da
                      instaladora
                    </p>
                  </div>
                )}
              </form>
            </div>
          </div>
        </Container>
      </section>

      {loading && <LoadingModal />}

      {modalResult.visible && (
        <RastreadoresModal
          sucesso={modalResult.success}
          titulo={modalResult.title}
          mensagem={modalResult.text}
          onDismiss={() => {
            setModalResult({ visible: false, title: '', text: '' });
          }}
        />
      )}
      <style jsx>{Styles}</style>
    </>
  );
}

export default RastreadoresFormV2;
